import { fireLogEvent, isEmpty, Namespace } from '@chegg/commerce-utils';
import { StoreBuilder } from './ReduxStoreUtil';
// consumers can call this method to update configs from outside of the react app.
export var update = function update(props) {
  var store = StoreBuilder().getStore({
    config: props.config
  });
  triggerUpdate(store, props);
};
export var triggerUpdate = function triggerUpdate(store, props) {
  var config = props.config,
    commands = props.commands;
  store.dispatch({
    type: '',
    payload: config
  });
  if (commands && !isEmpty(commands)) {
    store.dispatch({
      type: '',
      payload: commands
    });
  }
};
export var fireCallbackLoggingEvent = function fireCallbackLoggingEvent(logObj) {
  fireLogEvent(logObj, Namespace.USER_ADDRESS);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/CallbackUtil.js
// module id = 391
// module chunks = 11